import React, { useEffect } from "react";
import moment from "moment";
import { TableHeaderColumn, BootstrapTable } from "/src/component/table/BootstrapTable";

import Loading from "../../../component/Loading";
import { dataTableConfig } from "../../../config/config";
import { VISIT_PAGE } from "../../../config/lang";

import { call } from "../../../util/action";
import { getStore } from "../../../util/redux/store";
import { translate } from "../../../util/util";

const me = getStore().getState().me;

function Returns({ data }) {
  const [state, setState] = React.useState({ returns: "", loading: false });

  useEffect(() => {
    setState(prev => ({ ...prev, loading: true }));
    let url = `visits/${data.id}/returns_in_visit/`;

    call({ method: "GET", url }, response => {
      setState(prev => ({
        ...prev,
        returns: response,
        loading: false,
      }));
    });
  }, [data.id]);

  const getDateChange = (item, obj) => {
    if (!item) {
      return <span>-</span>;
    }

    let newDate = new Date(item);
    const date = moment(newDate).format("DD/MM/yyyy");
    return date;
  };

  const getTaskRowStatusClass = item => {
    if (!item.status) return;
    const str = item.status.toLowerCase();
    const result = str.replace(/ /g, "-");
    return result;
  };

  const getCounterpartyInfo = item => {
    if (!item) {
      return <span>-</span>;
    }
    return `<span>${item.name}</span>`;
  };

  const getPhysicalReturn = string => {
    if (!string) {
      return <span>-</span>;
    }
    return `<span>${string}</span>`;
  };

  const getCommentReturn = item => {
    if (!item) {
      return <span>-</span>;
    }
    return `<span>${item}</span>`;
  };

  return (
    <>
      <div className="returns-task-tab-wrapper">
        {state?.returns ? (
          <>
            <BootstrapTable
              data={state.returns}
              version="4"
              striped
              hover
              bordered={false}
              pagination={false}
              search={false}
              multiColumnSearch={true}
              columnFilter={false}
              options={{ ...dataTableConfig }}
              className="themed-main-table-container"
              trClassName={row => `returns-task-tab-item ${getTaskRowStatusClass(row)}`}
              tableHeaderClass="primary">
              <TableHeaderColumn dataField="id" isKey width="60px">
                {translate(VISIT_PAGE, "orders_return_id_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="status" width="60px">
                {translate(VISIT_PAGE, "orders_status_return_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={getCounterpartyInfo} dataField="counterparty" width="60px">
                {translate(VISIT_PAGE, "orders_popup_counterparty_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={(item, obj) => getDateChange(item, obj)} dataField="created" width="60px">
                {translate(VISIT_PAGE, "orders_return_crated_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={getPhysicalReturn} dataField="date_of_physical_return" width="60px">
                {translate(VISIT_PAGE, "orders_physical_return_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={getCommentReturn} dataField="comment" width="60px">
                {translate(VISIT_PAGE, "orders_popup_comment_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="visit" width="60px">
                {translate(VISIT_PAGE, "orders_popup_visit_label", me.language)}
              </TableHeaderColumn>
            </BootstrapTable>
          </>
        ) : (
          <Loading loading={state.loading} />
        )}
      </div>
    </>
  );
}

export default Returns;
